import * as actionTypes from 'actions';

const initialState = {
    Loading: false,
    emailReportSetupList: [],
    emailReportSetupRecord: [],
    validation_error: "",
    redirect_to_list: false,
    showDeleteModel: false,
    showUpdateForm: false,
    showViewPage: false, 
}

const EmailReportSetupReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.EMAIL_REPORT_SETUP_REQUEST:
            return {
                ...state,
                Loading: true,
                validation_error: "",
                redirect_to_list: false,
            }
        case actionTypes.EMAIL_REPORT_SETUP_SERVER_SUCCESS:
            return {
                ...state,
                Loading: false,
                redirect_to_list: false,
                validation_error: "",
                showUpdateForm: false,
                showViewPage: false,
               emailReportSetupRecord: [],
            }    
        case actionTypes.EMAIL_REPORT_SETUP_SUCCESS:
            return {
                ...state,
                Loading: false,
                redirect_to_list: false,
                validation_error: "",
               emailReportSetupList: action.emailReportSetupList,
                showUpdateForm: false,
                showViewPage: false,
               emailReportSetupRecord: [],
            }
        case actionTypes.EMAIL_REPORT_SETUP_GET_SUCCESS:
            return {
                ...state,
                Loading: false,
                redirect_to_list: false,
               emailReportSetupRecord: action.record,
                showUpdateForm: (action.actionType === 'update') ? true : false,
                showViewPage: (action.actionType === 'view') ? true : false
            }
        case actionTypes.EMAIL_REPORT_SETUP_VALIDATION_ERROR:
            return {
                ...state,
                Loading: false,
                redirect_to_list: false,
                validation_error: action.validation_error,
            }
        case actionTypes.HIDE_EMAIL_REPORT_SETUP_FEILD_VALIDATION_ERROR:
            if (state.validation_error && state.validation_error[action.feild_key])
                delete state.validation_error[action.feild_key]
            return {
                ...state,
                Loading: false,
                redirect_to_list: false,
                validation_error: action.validation_error,

            }
        case actionTypes.REDIRECT_TO_EMAIL_REPORT_SETUP_LIST:
            return {
                ...state,
                redirect_to_list: true,
                showUpdateForm: false,
                showViewPage: false,
                validation_error: "",
               emailReportSetupRecord: [],
            }
        default:
            return state;
    }
}

export default EmailReportSetupReducer;